/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
	* Unauthorized copying of this file, via any medium is strictly prohibited
	* Proprietary and confidential
	* Written by Aetonix, June 19, 2014
	* For information or permission request, email info@aetonixsystems.com
	*/

var Model = require("../types/Model.js");

module.exports = Model({
	name: "surveyinitiate",
	init: init,
	triggers: triggers,
	listeners: listeners,

	_surveys: [],
	_coreforms: null,
	_coreforms_id: [],

	add_submission: add_submission,
	remove_submission: remove_submission,
	validate: validate

});

function init() {
	var surveys = this._surveys;

	this.push({
		surveys: surveys,
	});
}

function listeners() {
	return {
		"coreforms:updated": handle_coreforms,
		"mqtt:$/survey/updated": handle_responded,
		"mqtt:$/survey/send": handle_survey_sent,
	};
}

function triggers() {
	return ({
		send: handle_send // send out a survey to a managed user
	});
}

function handle_survey_sent(data) {
	var schema = data.schema;
	var submission = data.submission;
	var managee = data.managee;
	this.add_submission(submission, schema, managee);
}

function handle_responded(data) {
	var submission = data.submission;
	this.remove_submission(submission);
	if (!this.data.surveys.length) {
		this.extend({
			pending: false
		});
	}
}

function handle_send(data) {
	var managee = data.managee;
	var schema = data.schema;
	var group = data.group;

	if (!this.validate(schema)) return;

	this.emit("usermetrics:trigger:track", "send survey", {
		schema: schema,
		managee: managee
	});
	this.api.manage.forms.survey.send(managee, schema, group);
}

function add_submission(submission, schema, managee) {
	var old = this.data.surveys;
	var updated = old.concat([{
		managee: managee,
		submission: submission,
		schema: schema
	}]);

	this.extend({
		surveys: updated,
		pending: true
	});
}

function remove_submission(submission) {
	var old = this.data.surveys;
	var remaining_submissions = true;
	var filtered = old.filter(function (item) {
		return item.submission !== submission;
	});

	if (filtered.length === 0) remaining_submissions = false;
	this.extend({
		surveys: filtered,
		pending: remaining_submissions
	});
}

function handle_coreforms(data) {
	this._coreforms = data;
	var keys = Object.keys(data);
	this._coreforms_id = keys.map(function(core) {
		return data[core]._id;
	});
}

/**
 * Make sure survey schema is a valid one.
 */
function validate(schema) {
	var valid = Object.keys(this._coreforms);
	if (valid.indexOf(schema) !== -1) return true;
	return false;
}
